import React from 'react';
import { SummaryItem } from '../../../../../shared/Summary/SummaryItem/SummaryItem';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import {
  createHoaDetailsAction,
  deleteHoaDetailsAction,
  getHoaDetailsAction,
  updateHoaDetailsAction,
} from 'store/order/orderHoa/slices';
import { IHoaForm, IUpdateHoaRequest } from 'types/order/hoa/IHoaDetailsTypes';
import { useAppDispatch } from 'store/store';
import { useSelectCurrentOrderId } from 'selectors/order/selectCurrentOrder';
import { EditHoaInline } from './EditHoaInline';

export const HoaSummaryItemContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const orderId = useSelectCurrentOrderId()!;
  const hoaDetails = useSelector(({ order }: RootStore) => order.hoa.getHoaDetailsSlice[orderId].data || []);

  const onReset = async () => {
    dispatch(getHoaDetailsAction(orderId));
  };

  const onSave = async (formValues: IHoaForm, index: number) => {
    const request: IUpdateHoaRequest = { orderId: formValues.orderId, ...formValues.hoas[index] };
    if (formValues.hoas[index].id === undefined) {
      await dispatch(createHoaDetailsAction(request));
    } else {
      await dispatch(updateHoaDetailsAction(request));
    }
    await onReset();
  };

  const onDelete = async (formValues: IHoaForm, index: number) => {
    const request: IUpdateHoaRequest = { orderId: formValues.orderId, ...formValues.hoas[index] };
    await dispatch(deleteHoaDetailsAction(request));
    // await onReset();
  };

  return (
    <SummaryItem label={'HOA'} tab={'other'}>
      <EditHoaInline onReset={onReset} onSave={onSave} onDelete={onDelete} orderId={orderId} hoaDetails={hoaDetails} />
    </SummaryItem>
  );
};
